import { render } from "./OverviewHeaderBet.vue?vue&type=template&id=2cefa21c"
import script from "./OverviewHeaderBet.vue?vue&type=script&lang=js"
export * from "./OverviewHeaderBet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__